// extracted by mini-css-extract-plugin
var _1 = "accordion__A7ekI";
var _2 = "add-button__PIU7g";
var _3 = "error-badge__M68oA";
var _4 = "error-badges__slNSj";
var _5 = "extended-property-list__FrOIk";
var _6 = "header__mO050";
var _7 = "list__S1i6L";
export { _1 as "accordion", _2 as "add-button", _3 as "error-badge", _4 as "error-badges", _5 as "extended-property-list", _6 as "header", _7 as "list" }
